import requestor from "../../requestor";

export default class AlertApi {
  all = () => requestor.get("/manage/alert_all");
  one = (id) => requestor.get("/manage/alert_one", { id: id });
  create = () => requestor.post("/manage/alert_create");
  save = (form) => requestor.patch("/manage/alert_save", { Alert: form });
  remove = (id) => requestor.delete("/manage/alert_delete", { id: id });
}
